import React, { useState, useRef, useEffect, useContext } from 'react';

import scrollTo from '../util/scrollTo';
import scrollTop from '../util/scrollTop';
import isNumeric from '../util/isNumeric';
import getRand from '../util/getRand';
import {
  getData,
  saveToDB,
  clearDB,
  playerSettingsKey,
  userSettingsKey
} from '../util/dbUtils';

import { globalKeyboardInteraction, Keys } from '../util/keyboardInteraction';
import PlayListItem from './PlayListItem';
import { Modal, ModalType } from '../Modal';
import { Resources } from './Resources';
import PlayerHeader from './PlayerHeader';
import quranData from '../services/quran_cdn_ahmed_ibn_3ali_al-3ajamy.json';
import quranChaptersInformations from '../services/quran_chapters_info.json';
import quranReciters from '../services/quran_reciters.json';
import SearchContext from '../SearchContext';

//import NavBar from "./NavBar"
/**
 * TODOS:
 * when the loader is showing then disable any clicking on the buttons
 *
 * تحسين ضهور معلومات ال modal
 *
 * اضافة animation الى ال modal
 *
 *
 * fix when clicking on the mute button
 * add keyboard interations
 * handle close opened menus automatically when unfocusing
 */
const openedElementsState = {
  dropDownIsOpen: false
};
let appIsFirstLoaded = true;
const Player = () => {
  //TODO: add init functions to these

  const [recitersList, updateRecitersList] = useState(quranReciters);
  const initReciter = () => {
    let userSettings = getData(userSettingsKey);
    //TODO:add try catch for invalid keys
    if (userSettings.length !== 0) {
      const idx_ = +userSettings['last_selected_reciter_index'];

      return quranReciters[idx_];
    } else {
      return quranReciters[0];
    }
  };
  const [currentReciter, updateCurrentReciter] = useState(initReciter); /**** */
  const [audioCurrentTime, updateAudioCurrentTime] = useState(0);
  const [currentVolume, updateCurrentVolume] = useState(0.75);
  const [isActiveLoop, updateِIsActiveLoop] = useState(false);
  const [isAllLoopActive, updateِIsAllLoopActive] = useState(false);

  const lastPlayed = quranChapters_ => {
    let userSettings = getData(userSettingsKey);
    //TODO:add try catch for invalid keys
    if (userSettings.length !== 0) {
      const idx_ = +userSettings['last_played_chapter_index'];

      return quranChapters_[idx_];
    } else {
      return quranData[0];
    }
  };


  const [currentSelected, updateCurrentSelected] = useState(quranData[0]);
  const [currentPlaying, updateCurrentPlaying] = useState({
    ...quranData[0],
    isPlaying: false
  });
  /********** */
  const { searchQuery, updateِSearchQuery } = useContext(SearchContext);
  const [searchResults, setSearchResults] = useState([]);

  //const [selectedIndex, updateِSelectedIndex] = useState(0);
  /********** */
  const [activeDropDownIndex, updateِActiveDropDownIndex] = useState(-1);

  const [isOptionsListDropdownOpen, toggleOptionsListDropdown] = useState(
    false
  );
  const [listItemDropdown, toggleListItemDropdown] = useState(false);
  const [isActiveRecitersDropdown, toggleRecitersDropdown] = useState(false);
  /********** */
  const [isFavList, toggleFavList] = useState(false);
  const [favSize, updateFavSize] = useState(0);
  /********** */
  //init this from the database

  const handleCurrentReciter = async idx => {
    //updateCurrentReciter()
    const newReciter = recitersList[idx];
    if (currentReciter.id === newReciter.id) return;
    
    updateCurrentReciter(newReciter);
    if (isPlaying) {
      updateIsPlaying(false);
    }
    try {
      const newAllChaptersResponse = await fetch(newReciter.location);
      const newAllChapters = await newAllChaptersResponse.json();
      let userSettings = getData(userSettingsKey);
      //console.log(newAllChapters);//updataQuranChapters
      updataQuranChapters(newAllChapters);

      loadFavData(recitersList[idx].id, userSettings, newAllChapters);
      scrollTop();
      updateCurrentSelected(newAllChapters[0]);
      updateCurrentPlaying(newAllChapters[0]);
      requestAndPlayPauseChapter(newAllChapters[0], false);
      /**Update Database */

      //update db (possible redundancy with the bottom one)
      //make this global

      if (userSettings.length !== 0) {
        const rectrsAndFavChaptersIndexes =
          userSettings['reciters_and_fav_chapters_indexes'];
        //console.log('OLD USR SETTINGS/', userSettings);
        //userSettings['last_played_chapter_index']
        const newUserSettings = {
          last_selected_reciter_index: idx,
          last_played_chapter_index: 0,
          reciters_and_fav_chapters_indexes: rectrsAndFavChaptersIndexes
        };
        saveToDB(newUserSettings, userSettingsKey);
      }

      toggleRecitersDropdown(false);
    } catch (ex) {
      console.log(ex);
      // alert('could not fetch new reciter');
    }
  };
  const initAudioSrc = () => {
    let userSettings = getData(userSettingsKey);
    //TODO:add try catch for invalid keys
    if (userSettings.length !== 0) {
      const idx_ = +userSettings['last_played_chapter_index'];
      console.log('INIT AUDIO:', quranData[idx_].location);
      return quranData[idx_].location;
    } else {
      return quranData[0].location;
    }
  };
  const [isLoadingAudio, updateIsLoadingAudio] = useState(false);
  const [audioSrc, updateAudioSrc] = useState(quranData[0].location);
  const [audioLength, updateAudioLength] = useState(0);
  const [isPlaying, updateIsPlaying] = useState(false);
  /*
  const initQuranChapters = async () => {
    let userSettings = getData(userSettingsKey);
    //TODO:add try catch for invalid keys
    if (userSettings.length !== 0) {
      const idx_ = +userSettings['last_selected_reciter_index'];
      //return quranReciters[idx_];

      if (idx_ === 0) {
        return quranData;
      } else {
        //request new quran data file here with http request
        const newReciter = recitersList[idx_];
        const newAllChaptersResponse = await fetch(newReciter.location);
        const newAllChapters = await newAllChaptersResponse.json();

        //console.log('--->>', JSON.parse(newAllChapters));
        if (userSettings.length !== 0) {
          //TODO:add try catch for invalid keys
          loadFavData(currentReciter.id, userSettings, newAllChapters);
        }

        return quranData;
      }
    } else {
      return quranData;
    }
  };*/

  /********** */ const [quranChapters, updataQuranChapters] = useState([]);
  const [chaptersCount, updataChaptersCount] = useState(quranData.length);

  const getMainGraphic = () => {
    const numbrOfGraphics = 5;
    let randGraphic = getRand(1, numbrOfGraphics);
    return Resources.QURAN_MAIN_3;
    //`${Resources.BASE_THUMBNAILS_LINK}/${randGraphic}.png`;
  };
  const [mainGraphicSrc, updateMainGraphicSrc] = useState(getMainGraphic);
  const [modalData, updateModalData] = useState({ isOpen: false });

  const handleOpenModal = (type, chapter = currentPlaying) => {
    //alert(type);
    let newModalData = { isOpen: false };

    switch (type) {
      case ModalType.CHAPTER_INFO:
        let vrseData = quranChaptersInformations[chapter.order - 1];

        newModalData = {
          ...modalData,
          title: `معلومات حول  ${vrseData.name}`,
          data: vrseData.info.description
        };
        break;
      case ModalType.RECITER_INFO:
        newModalData = {
          ...modalData,

          title: `معلومات حول القارئ ${currentReciter.name}`,
          data: currentReciter.info
        };
        break;
      case ModalType.APP_ABOUT:
        newModalData = {
          ...modalData,
          title: 'حول التطبيق',
          data: 'تطبيق من تطوير وتصميم المهندس ¤ ناصر صلاح الدين'
        };
        break;

      default:
        console.log('default case modal type');
        newModalData = {
          ...modalData,
          title: 'UNKNOWN',
          data: 'OTHER'
        };
    }

    newModalData.isOpen = true;
    updateModalData(newModalData);
  };
  //REFS HOOKS
  const timelineProgressRef = useRef();
  const audioRef = useRef();


  useEffect(() => {
    // Anything in here is fired on component did mount.

    let playerSettings = getData(playerSettingsKey);
    //let favChaptersData_ = getData(userSettingsKey)[currentReciter.name];
    let userSettings = getData(userSettingsKey);

    if (userSettings.length === 0) {
      //Note: reset data to empty fav
      const rectrsAndFavChaptersIndexes = quranReciters.reduce(
        (acc, cur) => ({
          ...acc,
          [cur.id]: {
            fav_list: [],
            info: cur
          }
        }),
        {}
      );

      const newUserSettings = {
        last_selected_reciter_index: 0,
        last_played_chapter_index: 0,
        reciters_and_fav_chapters_indexes: rectrsAndFavChaptersIndexes
      };

      saveToDB(newUserSettings, userSettingsKey);
    }
    //PLAYER SETTINGS
    if (playerSettings && playerSettings.length !== 0) {
      //TODO:add try catch for invalid keys
      try {
        let volume = playerSettings['volume'];
        let isCurrentChapterReplayOn = playerSettings['is_replay_on'];
        let isAllChaptersReplayOn = playerSettings['is_all_play_on'];
        let lastPlayedTime = +playerSettings['last_play_time'];

        if (volume >= 0 || volume <= 1) {
          updateCurrentVolume(volume);
          audioRef.current.volume = volume;
        }
        if (isAllChaptersReplayOn)
          updateِIsAllLoopActive(isAllChaptersReplayOn);

        if (isCurrentChapterReplayOn) {
          updateِIsActiveLoop(isCurrentChapterReplayOn);
          audioRef.current.loop = isCurrentChapterReplayOn;
        }
      } catch (exception) {
        console.log('Init user settings error!');
      }
    } else {
      //init db

      //DEBUG: JSON.parse(localStorage.getItem("user_settings"))
      saveToDB(
        {
          volume: 0.75,
          is_replay_on: false,
          is_all_play_on: true,
          last_play_time: 0
        },
        playerSettingsKey
      );
      userSettings = getData(userSettingsKey);
    }

    //document.addEventListener("click",handleOpenedItems);
    //globalKeyboardInteraction(handleKeyboardEvent)

    const idx_ = +userSettings['last_selected_reciter_index'];
    //console.log('idx is:', userSettings['last_selected_reciter_index']);
    if (!idx_ || idx_ === 0) {
      loadFavData(currentReciter.id, userSettings, quranData);
      updataQuranChapters(quranData);
      const lastPlayedChapter = lastPlayed(quranData);
      updateCurrentPlaying({ ...lastPlayedChapter, isPlaying: false });
      updateCurrentSelected(lastPlayedChapter);
      requestAndPlayPauseChapter(lastPlayedChapter, false);
      console.log('>>>>>>', lastPlayedChapter);
    } else {
      const newReciter = recitersList[idx_];
      fetch(newReciter.location)
        .then(response => {
          if (response.status !== 200) {
            console.log(
              'Looks like there was a problem. Status Code: ' + response.status
            );
            return;
          }
          return response.json();
        })
        .then(function(data) {
          //console.log('--->>', JSON.parse(newAllChapters));
          if (userSettings.length !== 0) {
            //TODO:add try catch for invalid keys
            // console.log(data);
            loadFavData(currentReciter.id, userSettings, data);
            updataQuranChapters(data);
            const lastPlayedChapter = lastPlayed(data);

            updateCurrentSelected(lastPlayedChapter);
            /*
            updateCurrentPlaying({ ...lastPlayedChapter, isPlaying: false });
            */
            requestAndPlayPauseChapter(lastPlayedChapter, false);
          }
        })
        .catch(function(err) {
          console.log('Fetch Reciter Error :', err);
        });
    }

    //updataQuranChapters(initQuranChapters);
    return () => {
      // Anything in here is fired on component unmount.
      document.removeEventListener('click', () => {});
      document.removeEventListener('keyup', () => {});
    };
  }, []);
  useEffect(() => {
    if (appIsFirstLoaded) {
      appIsFirstLoaded = false;
      return;
    }

    //console.log('searching');
    let results = [];

    if (!isFavList || searchQuery !== '') {
      const seartchQ = searchQuery.toLowerCase().trim();
      if (isNumeric(seartchQ) && +seartchQ > 0 && +seartchQ <= chaptersCount) {
        /*Search by Number  */
        results = [quranChapters[+seartchQ - 1]];
      } else {
        /*Search by Name */
        if (searchQuery !== '') {
          results = quranChapters.filter(chapter => {
            if (
              chapter.name.toLowerCase().includes(searchQuery.toLowerCase())
            ) {
              return chapter;
            }
          });
        } else {
          results = quranChapters;
        }
      }
    } else {
      results = quranChapters.filter(chapter => {
        if (chapter.isFav) {
          return chapter;
        }
      });
    }
    setSearchResults(results);
  }, [searchQuery, isFavList]);
  useEffect(() => {
    // console.log('search result:', searchResults.length);
    if (searchResults.length === 0) {
      scrollTop();
    } else if (searchResults.length === 1) {
      scrollTop();
      if (searchResults[0].order !== currentSelected.order) {
        updateCurrentSelected(searchResults[0]);
      }
    } else if (searchResults.length === chaptersCount) {
      //Note: since updating the same object will not execute its useEffect
      //we will scroll automatically
      //console.log('we will scroll automatically');
      scrollToCurrentPlaying(currentSelected, isFavList);
    } else {
      //multiple results

      if (isFavList && searchQuery === '') {
        // console.log('multiple results fav...');
        if (currentSelected.isFav) {
          scrollToCurrentPlaying(currentSelected, isFavList);
        } else {
          updateCurrentSelected(searchResults[0]);
        }
      } else {
        scrollTop();
        if (searchResults[0].order !== currentSelected.order) {
          // console.log('multiple results...');
          updateCurrentSelected(searchResults[0]);
        }
      }
    }
  }, [searchResults]);
  useEffect(() => {
    console.log('current selected scroll');
    scrollToCurrentPlaying(currentSelected, isFavList);
  }, [currentSelected]);

  /******************************************************* */

  const loadFavData = (reciterID, data_, quranChapters_) => {
    //TODO:add try catch for invalid keys

    if (quranChapters_ && quranChapters_.length > 0) {
      let favData =
        data_['reciters_and_fav_chapters_indexes'][reciterID]['fav_list'];
      let favLen = favData.length;
      console.log('loadFavData -------', favData.length);
      //console.log('-------', currentReciter);
      if (favLen !== 0) {
        //init from database

        //console.log('putting fav shit');
        let chaptersAll = [...quranChapters_];

        for (let idx of favData) {
          chaptersAll[idx.index].isFav = true;
        }
        updataQuranChapters(chaptersAll);
      }
      updateFavSize(favLen);
      if (searchQuery !== '') updateِSearchQuery('');
      if (isFavList) toggleFavList(false);
    } else {
      console.log('no chapter');
    }
  };
  const handleNextChapter = () => {
    //Moves to the next of the current selected List item or chapter
    if (searchQuery !== '') updateِSearchQuery('');
    if (isFavList) toggleFavList(false);
    //can be updated to move to next within the search result or in the favlist
    let idx = currentSelected.order - 1;

    if (idx + 1 >= quranChapters.length) {
      idx = 0;
    } else {
      idx = idx + 1;
    }

    updateCurrentSelected(quranChapters[idx]);
  };
  const handleNextPlayChapter = () => {
    //Moves to the next of the current PLAYING List item or chapter
    if (searchQuery !== '') updateِSearchQuery('');
    if (isFavList) toggleFavList(false);
    //can be updated to move to next within the search result or in the favlist
    let idx = currentPlaying.order - 1;

    if (idx + 1 >= quranChapters.length) {
      idx = 0;
    } else {
      idx = idx + 1;
    }
    return quranChapters[idx];
  };
  const handleIsAllLoopActive = () => {
    if (isActiveLoop) {
      updateِIsActiveLoop(false);
      audioRef.current.loop = false;
    }
    const isAllLooping_ = !isAllLoopActive;
    updateِIsAllLoopActive(isAllLooping_);
    const playerSettings = getData(playerSettingsKey);

    if (playerSettings.length !== 0) {
      //add try catch

      saveToDB(
        {
          volume: currentVolume,
          is_replay_on: false,
          is_all_play_on: isAllLooping_,
          last_play_time: 0
        },
        playerSettingsKey
      );
    }
  };
  const handlePrevChapter = () => {
    if (searchQuery !== '') updateِSearchQuery('');
    if (isFavList) toggleFavList(false);
    console.log('prev chapter');
    let idx = currentSelected.order - 1;

    if (idx !== 0) {
      idx = idx - 1;
    } else {
      idx = quranChapters.length - 1;
    }
    updateCurrentSelected(quranChapters[idx]);
    //scrollToCurrentPlaying(quranChapters[idx], isFavList);
  };
  const handleRandomChapter = () => {
    console.log('random chapter');
    let randIdx = getRand(0, quranChapters.length - 1);
    goToListItem(randIdx);
  };
  const goToListItem = idx => {
    if (searchQuery !== '') updateِSearchQuery('');
    if (isFavList) toggleFavList(false);

    if (currentSelected.order === quranChapters[idx].order) {
      scrollTo(idx);
    } else {
      updateCurrentSelected(quranChapters[idx]);
    }

    //scrollToCurrentPlaying(quranChapters[randIdx], isFavList);
  };
  const handleFav = chapter => {
    /*
    DEBUG IN browser
    JSON.parse(localStorage.getItem("user_settings"))
    JSON.parse(localStorage.getItem("user_settings"))["reciters_and_fav_chapters_indexes"][1].fav_list
    */
    const allChapters_ = [...quranChapters];
    const index_ = chapter.order - 1;

    allChapters_[index_].isFav = !chapter.isFav ? true : false;
    let isFav = allChapters_[index_].isFav;

    updataQuranChapters(allChapters_);
    if (chapter.order === currentPlaying.order) {
      updateCurrentPlaying(allChapters_[index_]);
    }

    let favSize_;
    //update db
    //make this global
    let userSettings = getData(userSettingsKey);

    if (userSettings.length !== 0) {
      //add try catch
      let favData =
        userSettings['reciters_and_fav_chapters_indexes'][currentReciter.id][
          'fav_list'
        ];
      favSize_ = favData.length;
      //console.log(favData);
      if (isFav) {
        /*adding to db*/
        favData.push({ index: index_ });
        // console.log('adding to db:', favData);
        favSize_ += 1;
      } /*removing from db*/ else {
        favData = favData.filter(item => {
          return item.index !== index_;
        });
        // console.log('removing from db:', favData);
        favSize_ -= 1;
      }
      userSettings['reciters_and_fav_chapters_indexes'][currentReciter.id][
        'fav_list'
      ] = favData;

      const rectrsAndFavChaptersIndexes =
        userSettings['reciters_and_fav_chapters_indexes'];
      //console.log('OLD USR SETTINGS/', userSettings);
      const newUserSettings = {
        last_selected_reciter_index:
          userSettings['last_selected_reciter_index'],
        last_played_chapter_index: userSettings['last_played_chapter_index'],
        reciters_and_fav_chapters_indexes: rectrsAndFavChaptersIndexes
      };
      //console.log(newUserSettings);

      updateFavSize(favSize_);
      saveToDB(newUserSettings, userSettingsKey);
    }
  };
  //Handle toggle Fav for list items
  const handleToggleFav = chapter => {
    if(listItemDropdown){
      toggleListItemDropdown(false);
      updateِActiveDropDownIndex(-1);
    }
  
    handleFav(chapter);
  };

  const handleShowFavList = () => {
    //if (!isFavList) scrollTop();
    if (searchQuery !== '') {
      updateِSearchQuery('');
    }
    toggleFavList(!isFavList);
  };

  const showAllChaptersList = () => {
    if (searchQuery !== '') {
      updateِSearchQuery('');
    }
    if (isFavList) {
      toggleFavList(false);
    }
  };

  const handleSelectChapter = chapter => {
    /**handling opened dropdowns */
    toggleListItemDropdown(false);
    updateِActiveDropDownIndex(-1);
    /** */

    if (currentSelected.order === chapter.order) {
      scrollTo(currentSelected.order - 1);
    } else {
      updateCurrentSelected(chapter);
    }

    if (searchResults.length > 1 && searchQuery != '') {
      //when we have multiple search results
      console.log('scroll to:');
      let idx_ = searchResults.indexOf(chapter);
      console.log(idx_);
      scrollTo(idx_);
    }
    /*
    //save selected chapter as last selected
    let userSettings = getData(userSettingsKey);

    if (userSettings.length !== 0) {
      userSettings['last_played_chapter_index'] = chapter.order - 1;
      //console.log(userSettings);
      saveToDB(userSettings, userSettingsKey);
    }*/

    //playSelected(chapter);
  };
  /******************************************************* */

  const scrollToCurrentPlaying = (toThis, isFavList_) => {
    // console.log('scrolling now...', isFavList_);
    if (searchQuery === '') {
      if (isFavList_) {
        // console.log('should scroll to:');
        let idx_ = searchResults.indexOf(toThis);
        /// console.log('>>', idx_);
        scrollTo(idx_);
      } else {
        let idx_ = toThis.order - 1;
        scrollTo(idx_);
        //console.log('scrolling to :', idx_);
      }
    } else {
      //console.log('yo');
      //console.log(toThis);
    }
  };
  /******************************************************* */

  const handleKeyboardEvent = (evt, Keys) => {
    if (!evt) {
      evt = window.event;
    } // for old IE compatible
    let keycode = evt.keyCode || evt.which; // also for cross-browser compatible

    switch (keycode) {
      case Keys.LEFT:
        console.log('LEFT pressed');
        break;
      case Keys.UP:
        console.log('UP pressed');
        break;
      case Keys.RIGHT:
        console.log('RIGHT pressed');
        break;
      case Keys.DOWN:
        console.log('DOWN pressed');
        break;
      case Keys.SPACE:
        console.log('SPACE pressed');
        break;
      default:
        console.log('default pressed');
    }
  };
  const handleOpenedItems = () => {
    console.log('>>', openedElementsState.dropDownIsOpen);

    if (openedElementsState.dropDownIsOpen) {
      toggleListItemDropdown(false);
      openedElementsState.dropDownIsOpen = false;
      console.log('closing dropdown');
    }
  };

  const handleToggleListItemDropdown = idx => {
    updateِActiveDropDownIndex(idx);
    if (idx === activeDropDownIndex) {
      toggleListItemDropdown(!listItemDropdown);
      openedElementsState.dropDownIsOpen = !listItemDropdown;
    } else {
      toggleListItemDropdown(true);
      openedElementsState.dropDownIsOpen = true;
    }
  };

  const toggleOptionsDropdown = () => {
    toggleOptionsListDropdown(!isOptionsListDropdownOpen);
  };

  const toggleDropdown = () => {
    toggleRecitersDropdown(!isActiveRecitersDropdown);
    
    // updateMainGraphicSrc(getMainGraphic());
  };
  /******************************************************* */

  const dispatch = data => {
    if (data.type === 'SET_DURATION') {
      updateAudioLength(data.length);
    } else if (data.type === 'SET_CURRENT_TIME') {
      timelineProgressRef.current.style.width =
        (data.time / audioRef.current.duration) * 100 + '%';
      updateAudioCurrentTime(data.time);

      if (audioRef.current.duration == data.time) {
        console.log('ended playing');
        updateIsPlaying(false);
        audioRef.current.currentTime = 0;

        //note when selecting "single loop" we disable "all loop"
        //note when selecting "all loop" we disable "single loop"
        //play next if all loop is selected
        if (isAllLoopActive) {
          //play next chapter
          const nextSelected = handleNextPlayChapter();
          handlePlayPause(nextSelected);
        }
      }
    } else if (data.type === 'DATA_LOADED') {
      console.log('DATA_LOADED', currentPlaying);
      //Pause the loader

      //play the new loaded Audio
      audioRef.current.volume = currentVolume;

      if (isPlaying) {
        audioRef.current.play();
        updateIsLoadingAudio(false);
        //Add to database as last_played
        let userSettings = getData(userSettingsKey);

        if (userSettings.length !== 0) {
          const rectrsAndFavChaptersIndexes =
            userSettings['reciters_and_fav_chapters_indexes'];

          const newUserSettings = {
            last_selected_reciter_index:
              userSettings['last_selected_reciter_index'],
            last_played_chapter_index: currentPlaying.order - 1,
            reciters_and_fav_chapters_indexes: rectrsAndFavChaptersIndexes
          };
          //console.log(newUserSettings);

          saveToDB(newUserSettings, userSettingsKey);
        }
      }
    }
  };
  const toggleMute = e => {
    let newVolume;
    if (currentVolume > 0) {
      newVolume = 0;
    } else {
      //This sould be the last volume
      newVolume = 0.75;
    }

    updateCurrentVolume(newVolume);
    audioRef.current.volume = newVolume;

    //Save volume as zero in database
    const playerSettings = getData(playerSettingsKey);

    if (playerSettings.length !== 0) {
      //add try catch

      saveToDB(
        {
          volume: newVolume,
          is_replay_on: isActiveLoop,
          is_all_play_on: isAllLoopActive,
          last_play_time: 0
        },
        playerSettingsKey
      );
    }
  };
  const handleLoop = () => {
    if (isAllLoopActive) {
      updateِIsAllLoopActive(false);
    }
    const isLooping = !isActiveLoop;
    updateِIsActiveLoop(isLooping);
    audioRef.current.loop = isLooping;
    console.log('Looping:', audioRef.current.loop);
    //update database user settings

    const playerSettings = getData(playerSettingsKey);

    if (playerSettings.length !== 0) {
      //add try catch

      saveToDB(
        {
          volume: currentVolume,
          is_replay_on: isLooping,
          is_all_play_on: false,
          last_play_time: 0
        },
        playerSettingsKey
      );
    }
  };
  const handleVolume = e => {
    const sliderWidth = window.getComputedStyle(e.currentTarget).width;
    const newVolume = e.nativeEvent.offsetX / parseInt(sliderWidth);
    audioRef.current.volume = newVolume;

    updateCurrentVolume(newVolume);
    //Save volume in database
    const playerSettings = getData(playerSettingsKey);

    if (playerSettings.length !== 0) {
      //add try catch

      saveToDB(
        {
          volume: newVolume,
          is_replay_on: isActiveLoop,
          is_all_play_on: isAllLoopActive,
          last_play_time: 0
        },
        playerSettingsKey
      );
    }
  };
  const handleSeek = e => {
    const timelineWidth = window.getComputedStyle(e.currentTarget).width;
    const timeToSeek =
      (e.nativeEvent.offsetX / parseInt(timelineWidth)) *
      audioRef.current.duration;

    timelineProgressRef.current.style.width =
      (timeToSeek / audioLength) * 100 + '%';

    if (!isNaN(timeToSeek)) {
      audioRef.current.currentTime = timeToSeek;
      updateAudioCurrentTime(timeToSeek);
    }
  };
  const handlePlayPause = chapter => {
    //close the play list item options list
    if(listItemDropdown){
      toggleListItemDropdown(false);
      updateِActiveDropDownIndex(-1);
    }
  



    if (isNaN(audioRef.current.duration)) {
      console.log('reloading');
      audioRef.current.load();
      console.log(audioRef.current.duration);
      return;
    }
    console.log('play');
    if (chapter.order === currentPlaying.order) {
      if (isPlaying) {
        audioRef.current.pause();
        updateCurrentPlaying({ ...chapter, isPlaying: false });
        updateIsPlaying(false);
      } else {
        audioRef.current.play();
        updateCurrentPlaying({ ...chapter, isPlaying: true });
        updateIsPlaying(true);
      }
    } else {
      console.log('playing a new one');
      requestAndPlayPauseChapter(chapter, true);
    }
  };
  const requestAndPlayPauseChapter = (chapter, willPlay) => {
    /**Pause if others are playing  */
    if (isPlaying) {
      console.log('pausing...................');
      audioRef.current.pause();
      updateCurrentPlaying({ ...currentPlaying, isPlaying: false });
      updateIsPlaying(false);
    }
    /******************************************** */

    let loc = chapter.location;
    updateAudioSrc(loc);
    console.log('waiting first ---->', loc);
    //TODO: add the current new chapter to the db as the last played chapter
    try {
      console.log('waiting ---->', loc);

      if (!isNaN(audioRef.current.duration)) {
        //Trigger a loader the covers the play button as an indicator of playing

        updateIsPlaying(willPlay);
        updateCurrentPlaying({ ...chapter, isPlaying: willPlay });
        updateCurrentSelected(chapter);
        updateIsLoadingAudio(true);
        /*
         */
      } else {
        console.error('IS NAN,Erorr loading:', loc);
        updateIsPlaying(false);
        updateCurrentPlaying({ ...chapter, isPlaying: false });
      }
    } catch (ex) {
      console.error('Erorr loading:', loc);
      updateIsPlaying(false);
      updateCurrentPlaying({ ...chapter, isPlaying: false });
    }

    // console.log(">", audioRef.current)
  };
  /******************************************************* */

  const showPlayList = () => {
    let showRes = [];

    if (searchQuery !== '') {
      if (searchResults.length > 0) {
        showRes = searchResults;
      } else {
        return (
          <div style={{ paddingTop: '.5rem' }}>
            <h1 style={{ margin: '1rem 0' }}>لم يتم العثور على أي سورة</h1>
            <img width="50%" src={Resources.NOT_FOUND_RES_1} />
          </div>
        );
      }
    } else if (!searchQuery && isFavList) {
      if (searchResults.length === 0) {
        return (
          <div style={{ paddingTop: '.5rem' }}>
            <h1 style={{ margin: '1rem 0' }}>لم يتم العثور على أي مفضلة</h1>
            <img width="50%" src={Resources.NOT_FOUND_RES_2} />
          </div>
        );
      } else {
        showRes = searchResults;
      }
    } else {
      showRes = quranChapters;
    }
    //console.log('>>>', showRes);
    return showRes.map((item, index) => {
      return (
        <PlayListItem
          handleOpenModal={handleOpenModal}
          isLoadingAudio={isLoadingAudio}
          item={item}
          key={index}
          index={index}
          isPlaying={isPlaying}
          currentPlaying={currentPlaying}
          currentSelected={currentSelected}
          isFav={item.isFav}
          isListItemDropdownOpen={listItemDropdown}
          activeDropDownIndex={activeDropDownIndex}
          onSelectChapterClick={handleSelectChapter}
          handlePlayPause={handlePlayPause}
          onToggleListItemDropdown={handleToggleListItemDropdown}
          onToggleFav={handleToggleFav}
          thumbnailImgSrc={mainGraphicSrc}
        />
      );
    });
  };
  return (
    <>
      <Modal modalData={modalData} updateModalData={updateModalData} />
      <div className="player has-text-centered">
        <PlayerHeader
          goToListItem={goToListItem}
          isAllLoopActive={isAllLoopActive}
          onIsAllLoopActive={handleIsAllLoopActive}
          handleOpenModal={handleOpenModal}
          currentSelected={currentSelected}
          currentPlaying={currentPlaying}
          recitersList={recitersList}
          isLoadingAudio={isLoadingAudio}
          favSize={favSize}
          searchQuery={searchQuery}
          quranChapters={quranChapters}
          chaptersCount={chaptersCount}
          audioSrc={audioSrc}
          audioRef={audioRef}
          handleCurrentReciter={handleCurrentReciter}
          toggleMute={toggleMute}
          currentReciter={currentReciter}
          handlePlayPause={handlePlayPause}
          showFavList={handleShowFavList}
          showAllChaptersList={showAllChaptersList}
          audioCurrentTime={audioCurrentTime}
          audioLength={audioLength}
          currentVolume={currentVolume}
          isPlaying={isPlaying}
          isFavList={isFavList}
          isOptionsListDropdownOpen={isOptionsListDropdownOpen}
          isActiveLoop={isActiveLoop}
          isActiveRecitersDropdown={isActiveRecitersDropdown}
          timelineProgressRef={timelineProgressRef}
          mainGraphicSrc={mainGraphicSrc}
          toggleDropdown={toggleDropdown}
          handleRandomChapter={handleRandomChapter}
          handlePrevChapter={handlePrevChapter}
          handleLoop={handleLoop}
          handleFav={handleFav}
          handleNextChapter={handleNextChapter}
          handleVolume={handleVolume}
          handleSeek={handleSeek}
          toggleOptionsDropdown={toggleOptionsDropdown}
          dispatch={dispatch}
        />
        <div className="player-body">
          <div className="play-list">{showPlayList()}</div>
        </div>
      </div>
    </>
  );
};

export default Player;
